import Vue from 'vue'

export default (ctx, inject) => {
  const bus = new Vue()
  ctx.$bus = bus
  inject('bus', bus)
}
